module.exports = __webpack_public_path__ + "img/21ne.3fad3a05.svg";